import React, { useState } from "react";
import styled from "styled-components";
import "./SkillInsightCard.css";

import {
  Card as MuiCard,
  CardContent,
  Typography,
  Collapse,
  Box,
  Rating,
  useMediaQuery
} from "@mui/material";


const Card = styled(MuiCard)`
  background-color: #1b1a2ea9 !important;
  color: white;
  box-shadow: 0 0px 3px 3px #ebc2f575;
  transition: all 0.5s ease 0s;
  margin-top: 1rem;
  width: 100%;
  font-family: "Montserrat", sans-serif;
`;

const Title = styled(Typography).attrs(() => ({
  className: "title",
}))`
  font-size: 1.2rem;
  color: #ffcc99;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionTitle = styled(Typography).attrs(() => ({
  className: "section-title",
}))`
  margin-top: 0.1rem;
  padding-left: 0.5rem;
  font-size: 1.1rem;
  text-align: left;
  color: #d4a5ff;
`;

const ListItem = styled("li").attrs(() => ({
  className: "list-item",
}))`
  text-align: left;
  color: #ddd;
  font-size: 0.9rem;
`;

const SkillCard = ({ skill, authenticated }) => {
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Card>
      <CardContent sx={{ padding: ".7rem !important" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setExpanded(!expanded)}
        >
          <Box>
            <Title>{skill.name}</Title>
          </Box>
          <Box>
            <Rating
              name="read-only"
              value={skill.rating / 2}
              precision={0.1}
              size={isMobile ? "small" : "medium"}
              readOnly
              sx={{
                color: "#ffc107", // Filled stars
                "& .MuiRating-iconEmpty": {
                  color: "#777", // Light gray for empty stars (adjust as needed)
                },
              }}
            />
          {!isMobile && (
  <span style={{ marginLeft: "8px", fontWeight: "bold" }}>
   {skill.rating.toFixed(1)} / 10
  </span>
)}
          </Box>
        </Box>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box>
            <SectionTitle className="summary" style={{ color: "#ece2f7" }}>
              {skill.summary}
            </SectionTitle>
            {skill.strengths?.length > 0 && (
              <>
                <SectionTitle>Strengths</SectionTitle>
                <ul>
                  {skill.strengths.map((s, idx) => (
                    <ListItem key={idx}>{s}</ListItem>
                  ))}
                </ul>
              </>
            )}

            {authenticated && skill.improvements_needed?.length > 0 && (
              <>
                <SectionTitle>Areas for Improvement</SectionTitle>
                <ul>
                  {skill.improvements_needed.map((s, idx) => (
                    <ListItem key={idx}>{s}</ListItem>
                  ))}
                </ul>
              </>
            )}

            {authenticated && skill.next_steps?.length > 0 && (
              <>
                <SectionTitle>Next Steps</SectionTitle>
                <ul>
                  {skill.next_steps.map((s, idx) => (
                    <ListItem key={idx}>{s}</ListItem>
                  ))}
                </ul>
              </>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default SkillCard;
